import React from "react";
import Slider from "react-slick";
import { Helmet } from "react-helmet";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./Clients.css";

const Clients = ({ images }) => {
    // Split images into two halves
    const mid = Math.ceil(images.length / 2);
    const firstHalf = images.slice(0, mid);
    const secondHalf = images.slice(mid);

    // Carousel settings for top (LTR)
    const settingsTop = {
        dots: false,
        infinite: true,
        speed: 2500,
        slidesToShow: 5,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 0,
        cssEase: "linear",
        pauseOnHover: true,
        swipeToSlide: true,
        draggable: true,
        rtl: false,
        responsive: [
            {
                breakpoint: 1400,
                settings: { slidesToShow: 4 }
            },
            {
                breakpoint: 900,
                settings: { slidesToShow: 2 }
            },
            {
                breakpoint: 600,
                settings: { slidesToShow: 1 }
            }
        ]
    };

    // Carousel settings for bottom (RTL)
    const settingsBottom = {
        ...settingsTop,
        rtl: true,
        speed: 3000,
        autoplaySpeed: 0,
    };

    return (
        <div className="clients-modern-container">
            <Helmet>
                <title>Our Clients | AptoWebsites - Trusted by Real Estate Professionals</title>
                <meta name="description" content="AptoWebsites is trusted by top real estate agents, teams, and brokerages. See some of our valued clients and partners." />
                <meta name="keywords" content="clients, real estate clients, trusted by, partners, AptoWebsites" />
                <meta property="og:title" content="Our Clients | AptoWebsites" />
                <meta property="og:description" content="AptoWebsites is trusted by top real estate agents, teams, and brokerages. See some of our valued clients and partners." />
                <meta property="og:type" content="website" />
                <meta property="og:url" content="https://aptowebsites.com/clients" />
                <meta property="og:image" content="https://aptowebsites.com/og-image.jpg" />
                <link rel="canonical" href="https://aptowebsites.com/clients" />
            </Helmet>
            <div className="clients-header-modern">
                <h1 className="clients-header titles">Some of the people we love</h1>
                <p className="clients-subtitle">
                    Trusted by top real estate agents, teams, and brokerages.
                </p>
            </div>
            <div className="clients-carousel-wrapper">
                <Slider {...settingsTop} className="clients-carousel clients-carousel-top">
                    {firstHalf.map((image, index) => (
                        <div key={index} className="client-slide-modern">
                            <img
                                src={image}
                                alt={`Client ${index + 1}`}
                                className="client-logo-modern"
                            />
                        </div>
                    ))}
                </Slider>
                <Slider {...settingsBottom} className="clients-carousel clients-carousel-bottom">
                    {secondHalf.map((image, index) => (
                        <div key={index} className="client-slide-modern">
                            <img
                                src={image}
                                alt={`Client {mid + index + 1}`}
                                className="client-logo-modern"
                            />
                        </div>
                    ))}
                </Slider>
            </div>
        </div>
    );
};

export default Clients;
